module.exports = __webpack_public_path__ + "img/9.7b28828b.jpg";